'use client'
import {
  __async
} from "./chunk-UYSR6ZT4.mjs";

// src/experiments/amplitude/client.ts
import { AnalyticsConnector } from "@amplitude/analytics-connector";
import { Experiment } from "@amplitude/experiment-js-client";
import { getItem, setItem, uuid } from "@wbk/utils";
var client = null;
var fetchPromise = null;
var DEVICE_ID_KEY = "wbk_exp_device_id";
var getOrCreateDeviceId = () => {
  let id = getItem(DEVICE_ID_KEY);
  if (!id) {
    id = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function" ? crypto.randomUUID() : uuid();
    setItem(DEVICE_ID_KEY, id);
  }
  return id;
};
var initExperimentClient = (apiKey) => {
  if (!client) {
    AnalyticsConnector.getInstance("$default_instance").identityStore.editIdentity().setDeviceId(getOrCreateDeviceId()).commit();
    client = Experiment.initializeWithAmplitudeAnalytics(apiKey);
  }
};
var getExperimentClient = () => {
  return client;
};
var fetchExperimentsOnce = (_0) => __async(null, [_0], function* ({ user_id }) {
  const experiment = getExperimentClient();
  if (!experiment) return;
  if (!fetchPromise) {
    fetchPromise = experiment.fetch({ user_id: user_id != null ? user_id : void 0 }).catch((error) => {
      fetchPromise = null;
      throw error;
    });
  }
  return fetchPromise;
});

export {
  initExperimentClient,
  getExperimentClient,
  fetchExperimentsOnce
};
//# sourceMappingURL=chunk-SKCYT5EL.mjs.map